module.exports = __webpack_public_path__ + "img/heels_pinup24heels.69ec925.png";